
import { Component, Vue } from "vue-property-decorator";
import store from "@/store/store";

@Component
export default class CancelAlertModal extends Vue {
  get showCancelAlert(): boolean {
    return store.getCancelAlert();
  }
  set showCancelAlert(cancelAlert) {
    store.setCancelAlert(cancelAlert);
  }
}
